module.exports = __webpack_public_path__ + "static/media/muss.4ef7376e.PNG";